// import logo from './logo.svg';
// import '../App.css';
import Todo from "./todo-components/Todo";
import Form from "./todo-components/Form";
import FilterButton from "./todo-components/FilterButton";
import React, { useState, useRef, useEffect } from "react";
import { nanoid } from "nanoid";

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function Home(props) {
  const [tasks, setTasks] = useState([]);

  function clearAll(){
    localStorage.clear();
    setTasks([]);
  }

  // Create a new clearAll button with the onClick -> 1. localStorage.clear() 2. setTasks([]);
  const FILTER_MAP = {

    All: () => true,
    Active: (task) => !task.completed,
    Completed: (task) => task.completed
  };

  const FILTER_NAMES = Object.keys(FILTER_MAP);

  // Gets data
  useEffect(() => {
    const init = localStorage.getItem('tasks');
    if (init){
      setTasks(JSON.parse(init));
    }
  }, []);

  // Sets data
  // NOTE: you do not update via localState since it should access from localStorage.
  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));
  });

  const [filter, setFilter] = useState('All');

  function addTask(name) {
    alert(name);
    const newTask = { id: `todo-${nanoid()}`, name, completed: false};
    setTasks([...tasks, newTask]);
  }
  // console.log(props.tasks);
  function toggleTaskCompleted(id) {
    // console.log(tasks[0]);
    const updatedTasks = tasks.map((task) => {
      // if this task has the same ID as the edited task
      if (id === task.id) {
        // use object spread to make a new object
        // whose `completed` prop has been inverted
        return {...task, completed: !task.completed}
      }
      return task;
    });
    setTasks(updatedTasks);
  }
  
  function deleteTask(id) {
    // console.log(id);
    const remainingTasks = tasks.filter((task) => id !== task.id);
    setTasks(remainingTasks);
  }
  
  const taskList = tasks
  .filter(FILTER_MAP[filter])
  .map((task) => (
    <Todo
      id={task.id}
      name={task.name}
      completed={task.completed}
      key={task.id}
      toggleTaskCompleted={toggleTaskCompleted}
      deleteTask={deleteTask}
      editTask={editTask}
    />
  ));


  const filterList = FILTER_NAMES.map((name) => (
    <FilterButton
      key={name}
      name={name}
      isPressed={name === filter}
      setFilter={setFilter}
    />
  ));

  const tasksNoun = taskList.length !== 1 ? 'tasks' : 'task';
  const headingText = `${taskList.length} ${tasksNoun} remaining`;

  function editTask(id, newName) {
    const editedTaskList = tasks.map((task) => {
    // if this task has the same ID as the edited task
      if (id === task.id) {
        //
        return {...task, name: newName}
      }
      return task;
    });
    setTasks(editedTaskList);
  }
  
  const listHeadingRef = useRef(null);
  const prevTaskLength = usePrevious(tasks.length);

  useEffect(() => {
    if (tasks.length - prevTaskLength === -1) {
      listHeadingRef.current.focus();
    }
  }, [tasks.length, prevTaskLength]);

  return (
    <>
      <h1>TodoMatic</h1>
      <Form addTask = {addTask} />
      <div className = "filters btn-group stack-exception">
        <button onClick = { () => clearAll()} className="btn toggle-btn btn__danger">Clear All</button>
      </div>
      <div className = "filters btn-group stack-exception">
        {/* <FilterButton /> */}
        {filterList}
      </div>
      <h2 id="list-heading" tabIndex="-1" ref={listHeadingRef}>
        {headingText}
      </h2>

      <ul
        className= "todo-list stack-large stack-exception"
        aria-labelledby="list-heading"
      >

        {taskList}

      </ul>
    </>
  );
}

export default Home;
